import { __assign, __decorate, __extends } from "tslib";
import React from 'react';
import { AppServices, Misc } from '@singularsystems/neo-core';
import Modal from './Modal';
import { observer } from 'mobx-react';
import ModalHelper from '@singularsystems/neo-core/dist/Components/Modal/ModalHelper';
var ModalContainer = /** @class */ (function (_super) {
    __extends(ModalContainer, _super);
    function ModalContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalStore = Misc.Globals.appService.get(AppServices.NeoTypes.UI.ModalStore);
        _this.containerRef = React.createRef();
        return _this;
    }
    ModalContainer.prototype.componentDidMount = function () {
        var _a;
        ModalHelper.initialise(this.props, (_a = this.containerRef.current) !== null && _a !== void 0 ? _a : undefined);
    };
    ModalContainer.prototype.componentDidUpdate = function () {
        ModalHelper.appInstance.updateProps(this.props);
    };
    ModalContainer.prototype.render = function () {
        var modalList = this.modalStore.modals.map(function (modal) { return (modal.refreshValue &&
            React.createElement(Modal, __assign({ key: modal.id }, modal.options), modal.content)); });
        if (this.props.renderInPlace) {
            return React.createElement("div", { ref: this.containerRef }, modalList);
        }
        else {
            return modalList;
        }
    };
    ModalContainer = __decorate([
        observer
    ], ModalContainer);
    return ModalContainer;
}(React.Component));
export default ModalContainer;
